import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20manga%20reading%20scene%2C%20warm%20golden%20and%20cream%20tones%2C%20abstract%20flowing%20ink%20and%20brush%20strokes%2C%20soft%20dreamy%20atmosphere%2C%20minimalist%20composition%2C%20elegant%20clean%20aesthetic%2C%20digital%20art%20with%20traditional%20Korean%20ink%20painting%20influence%2C%20subtle%20gradient%20background&width=1800&height=900&seq=hero-bg-01&orientation=landscape"
        alt="妖精漫画 - 免费在线韩国漫画"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="妖精漫画 - 免费在线观看海量韩国漫画"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4">
          妖精漫画
        </h1>
        <p className="text-base md:text-xl text-background-50/90 max-w-2xl mb-3 leading-relaxed">
          免费在线观看海量韩国漫画 · 下拉式韩漫大全
        </p>
        <p className="text-sm md:text-lg text-background-50/70 max-w-xl leading-relaxed">
          如同一个线上漫画博物馆，任您游览探索
        </p>
        <div className="flex items-center gap-3 mt-8">
          <Link
            to="/category/all"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-full text-base font-medium hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            立即阅读
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full text-base font-medium border border-background-50/30 hover:bg-background-50/30 transition-all whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
        <div className="flex items-center gap-6 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">3,200+</p>
            <p className="text-xs md:text-sm text-background-50/70 mt-1">收录漫画</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">580万+</p>
            <p className="text-xs md:text-sm text-background-50/70 mt-1">月活用户</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">98.5%</p>
            <p className="text-xs md:text-sm text-background-50/70 mt-1">好评率</p>
          </div>
        </div>
      </div>
    </section>
  );
}